<template>
    <td-dialog :title="$t(title)" :before-close="jobDialogClose" @cancel="jobDialogClose" :visible="dialogDetailIsible" width="850px" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="fromJobInifo" :label-width="formLabelWidth" ref="fromJobInifo">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_NAME')" prop="jobName">
                        <td-input type="input" :value="editItem.jobName" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_GROUP')" prop="groupName">
                        <td-input type="input" :value="editItem.groupName" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_CRON')" prop="cron">
                        <td-input type="input" :value="editItem.cron" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_BEAN_PATH')" prop="jobClassPath">
                        <td-input type="textarea" :rows="2" :value="editItem.jobClassPath" :readonly="true" width="100%"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_CONCURRENT')" prop="concurrent">
                        <td-input type="input" :value="$t('common.YES')" :readonly="true" v-if="editItem.concurrent"></td-input>
                        <td-input type="input" :value="$t('common.NOT')" :readonly="true" v-else></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.CURRENT_STATE')">
                        <td-input type="input" :value="$t('common.RUNNING')" :readonly="true" v-if="editItem.runState === running"></td-input>
                        <td-input type="input" :value="$t('common.WAITTING')" :readonly="true" v-else></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_STATE')">
                        <td-input type="input" :value="$t('common.ISUSING')" :readonly="true" v-if="editItem.jobState === start"></td-input>
                        <td-input type="input" :value="$t('common.UNUSING')" :readonly="true" v-else></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_NUMBER')" prop="jobNumber">
                        <td-input type="input" :value="editItem.jobNumber" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_RUNTIME')">
                        <td-input type="input" :value="runTime" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_AVERAGE_TIME')">
                        <td-input type="input" :value="AveTime" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.JOB_TOTAL_TIME')">
                        <td-input type="input" :value="totalTime" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.SUCCESS_COUNIT')">
                        <td-input type="input" :value="editItem.successCount" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.FAILE_COUNIT')">
                        <td-input type="input" :value="editItem.failedCount" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.TOTAL_COUNIT')">
                        <td-input type="input" :value="editItem.totalCount" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('common.ADD_TIME')" prop="addTime">
                        <td-input type="input" :value="editItem.addTime" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.UPDATE_TIME')" prop="updateTime">
                        <td-input type="input" :value="editItem.updateTime" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.DESCRIPTION')" prop="jobDescription">
                        <td-input type="textarea" :rows="2" :value="editItem.jobDescription" width="100%" :readonly="true"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button @click="jobDialogClose">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogDetailIsible', 'editItem'],
    created() {},

    // 定义变量
    data() {
        return {
            // 表单信息
            fromJobInifo: {
                jobKey: '',
                jobName: '',
                groupName: '',
                jobClassPath: '',
                cron: '',
                jobDescription: '',
                concurrent: false,
                jobNumber: '1',
                logSaveDays: 6,
                errorLogSaveDays: 6
            },
            formLabelWidth: '80px',
            running: window.pgCommon.jobRunState.RUNNING,
            start: window.pgCommon.jobRunState.JOB_STATE_START
        };
    },
    computed: {
        runTime: function() {
            let minute = 0;
            let hour = 0;
            let time = this.editItem.jobRunTime + 'ms';
            let second = this.editItem.jobRunTime / 1000;
            if (second > 1) {
                minute = second / 60;
                time = this.formatFloat(second, 2) + 's';
            }
            if (minute > 1) {
                hour = minute / 60;
                time = this.formatFloat(minute, 2) + 'min';
            }
            if (hour > 1) {
                time = this.formatFloat(hour, 2) + 'h';
            }
            return time;
        },
        AveTime: function() {
            let minute = 0;
            let hour = 0;
            let time = this.editItem.jobAverageTime + 'ms';
            let second = this.editItem.jobAverageTime / 1000;
            if (second > 1) {
                minute = second / 60;
                time = this.formatFloat(second, 2) + 's';
            }
            if (minute > 1) {
                hour = minute / 60;
                time = this.formatFloat(minute, 2) + 'min';
            }
            if (hour > 1) {
                time = this.formatFloat(hour, 2) + 'h';
            }
            return time;
        },
        totalTime: function() {
            let minute = 0;
            let hour = 0;
            let time = this.editItem.jobTotalTime + 'ms';
            let second = this.editItem.jobTotalTime / 1000;
            if (second > 1) {
                minute = second / 60;
                time = this.formatFloat(second, 2) + 's';
            }
            if (minute > 1) {
                hour = minute / 60;
                time = this.formatFloat(minute, 2) + 'min';
            }
            if (hour > 1) {
                time = this.formatFloat(hour, 2) + 'h';
            }
            return time;
        }
    },
    // 定义并实现方法体
    methods: {
        // 关闭窗口之前需要调用的方法
        time1(params) {
            let minute = 0;
            let hour = 0;
            let time = params.jobTotalTime + 'ms';
            let second = params.jobTotalTime / 1000;
            if (second > 1) {
                minute = second / 60;
                time = this.formatFloat(second, 2) + 's';
            }
            if (minute > 1) {
                hour = minute / 60;
                time = this.formatFloat(minute, 2) + 'min';
            }
            if (hour > 1) {
                time = this.formatFloat(hour, 2) + 'h';
            }
            return time;
        },
        // 数字格式化
        formatFloat(src, pos) {
            return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
        },
        jobDialogClose() {
            this.$log.info('jobDialogClose');
            this.$emit('jobDialogClose');
            this.$refs['fromJobInifo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
